// external
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';

// models, types
import { CallToActionPosition } from '@/interfaces/CallToActionTypes';
import { ICard } from '@/interfaces/Card';
import { IPromotion } from '@/interfaces/Promotion';
import { Partner } from '@/interfaces/Partner';
import { VuexAction } from '@/@types/index.d';

// store
import {
	GET_CURRENT_CARD,
	GET_FOOTER_BUTTON_CLICKED_REPORT,
	GET_THIRD_TAB_CLICK_REPORT,
	GET_VISIBLE_PROMOTIONS,
	SEND_REPORT,
} from '@/store/types';
import { IReport } from '@/interfaces/IReport';

@Component({})
export default class Instacart extends Vue {
	@Prop({ required: true }) label!: string;

	@Prop({ required: true }) position!: CallToActionPosition;

	@Getter(GET_CURRENT_CARD) getCurrentCard!: ICard;

	@Getter(GET_VISIBLE_PROMOTIONS) getVisiblePromotions!: IPromotion[];

	@Getter(GET_THIRD_TAB_CLICK_REPORT) getThirdTabClickReport!: IReport;

	@Getter(GET_FOOTER_BUTTON_CLICKED_REPORT)
	getFooterButtonClickedReport!: IReport;

	@Action(SEND_REPORT) sendReport!: VuexAction<IReport>;

	get uri(): string {
		let instaUri = this.getCurrentCard.callToActionUrl || '';
		this.getVisiblePromotions.forEach(
			(promo: IPromotion, index: number) => {
				// Skip the main promotion, it should be in the callToActionUrl already.
				if (index !== 0) {
					instaUri = `${instaUri}&ingredients%5B%5D=${encodeURIComponent(
						promo.productName
					)}`;
				}
			}
		);
		return instaUri;
	}

	handleClick() {
		const report = this.getThirdTabClickReport;
		report.mxrThirdTabButtonClicked!.button = {
			label: this.label,
			partner: Partner.INSTACART,
		};
		this.sendReport(report);
		this.sendReport(this.getFooterButtonClickedReport);
	}
}
